<template>
  <element>
    <AppBar :title="task ? task.taskName : ''" />
    <v-container>
      <v-icon class="icon" size=60 color="#2E384D">mdi-cogs</v-icon>
      <h5 class="subtitle w-100 text-center">{{ $t('backgroundTask.subtitle') }}.</h5>
      <p class="description text-center">{{ $t('backgroundTask.description') }}</p>
      <!-- <v-img src="../assets/cloud.mp4" alt="Cloud"></v-img> -->
      <v-row no-gutters justify="center" align="center">
        <v-col>
          <video autoplay loop muted playsinline width="350">
            <source src="../assets/cloud.mp4" type="video/mp4">
          </video>
        </v-col>
      </v-row>
      <v-btn class="btn" color="#D9753B" height=40 dark @click="makeFeedback">{{ $t('backgroundTask.button') }}</v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"

export default {
  name: "BackgroundTaskPage",
  props: {
    pid: String,
    title: String
  },
  components: {
    AppBar
  },
  data() {
    return {
      task: null
    }
  },
  methods: {
    makeFeedback() {
      this.$store.dispatch('showFeedbackDialog')
    }
  },
  created() {
    this.task = this.$store.getters.getCurrentTask
  }
}
</script>

<style scoped>
.icon {
  margin-top: 2.5rem;
  margin-bottom: 2.75rem;
}

.subtitle {
  color: #2E384D;
  font-size: 1.25rem;
  font-weight: bold;
}

.description {
  font-size: 0.875rem;
  font-weight: lighter;
  color: #2E384D;
  margin-top: 2.5rem;
}

.btn {
  margin-top: 3.75rem;
}

.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>